import { Fragment, h } from "preact";

import Button from "./Button.jsx";
import ModalForm from "./ModalForm.jsx";
import SubmitButton from "./SubmitButton.jsx";
import { createPortal } from "preact/compat";

export default function UnsavedChangesPrompt({
  acceptButton,
  cancelButton,
  onAccept,
  onCancel,
  text,
}) {
  return createPortal(
    <div class="nioomi-modal-wrapper">
      <ModalForm
        noOutsideClick
        onClose={onCancel}
        onSubmit={onAccept}
        buttonRow={
          <>
            <SubmitButton>{acceptButton}</SubmitButton>
            <Button secondary class="mr-8" onClick={onCancel}>
              {cancelButton}
            </Button>
          </>
        }
        opened={true}
      >
        <p>{text}</p>
      </ModalForm>
    </div>,
    document.getElementById("modals")
  );
}
